// Angular Imports
import { ChangeDetectionStrategy, Component, OnInit, computed, inject, signal } from '@angular/core'
import { environment } from '@environment'
// Shared Imports
import { EEnvironment } from '@shared/models'
import { EnvironmentStore } from '@shared/store'

@Component({
	standalone: true,
	imports: [],
	selector: 'app-environment-decorator',
	templateUrl: './environment-decorator.component.html',
	styleUrls: ['./environment-decorator.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentDecoratorComponent implements OnInit {
	readonly #environmentStore = inject(EnvironmentStore)
	readonly EEnvironment = EEnvironment

	environment = signal<EEnvironment>(EEnvironment.dev)
	hidden = signal<boolean>(false)
	version = computed(() => this.#environmentStore.version())

	ngOnInit(): void {
		// Set current environment
		environment.environment === EEnvironment.local && this.environment.set(EEnvironment.local)
		environment.environment === EEnvironment.dev && this.environment.set(EEnvironment.dev)
		environment.environment === EEnvironment.test && this.environment.set(EEnvironment.test)
		environment.environment === EEnvironment.prod && this.environment.set(EEnvironment.prod)
	}

	onHiddenDecoratorFor10Seg() {
		this.hidden.set(true)
		const timeoutId: number = window.setTimeout(() => {
			this.hidden.set(false)
		}, 10000)
	}
}
